import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import { selectContainerStyle } from "./multi_select.module.scss";

const MultiSelect = ({
  customComponents,
  defaultValue,
  isMulti,
  onChange,
  options,
  placeholder,
  selectProps,
  styles,
  value,
}) => {
  return (
    <ReactSelect
      className={selectContainerStyle}
      classNamePrefix="react-select"
      components={customComponents}
      value={value}
      isClearable
      defaultValue={defaultValue}
      isMulti={isMulti}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      selectProps={selectProps}
      styles={styles}
      closeMenuOnScroll={false}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      blurInputOnSelect
    />
  );
};

MultiSelect.propTypes = {
  customComponents: PropTypes.shape({}),
  isMulti: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selectProps: PropTypes.shape({}),
  styles: PropTypes.shape({}),
  value: PropTypes.arrayOf(PropTypes.shape).isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.shape),
};

MultiSelect.defaultProps = {
  customComponents: null,
  isMulti: false,
  placeholder: "Choose an option...",
  selectProps: null,
  styles: null,
  defaultValue: [],
};

export default MultiSelect;
